import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=37816201&"
import script from "./PropertyValue.vue?vue&type=script&lang=js&"
export * from "./PropertyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PropertyValue.vue"
export default component.exports